import { Parameter } from '../models/parameter.interface';

export interface ParameterState {
  parameters: Parameter[];
  selectedParameter: Parameter | null;
  loading: boolean;
  error: string | null;
  creating: boolean;
  updating: boolean;
  loadingParameterById: boolean;
  loadingActiveParameters: boolean;
  loadingInactiveParameters: boolean;

  // Cache state
  lastFetched: number | null;
  cacheValid: boolean;
  cacheExpiry: number | null;
  forceRefresh: boolean;
}

export const initialParameterState: ParameterState = {
  parameters: [],
  selectedParameter: null,
  loading: false,
  error: null,
  creating: false,
  updating: false,
  loadingParameterById: false,
  loadingActiveParameters: false,
  loadingInactiveParameters: false,

  // Cache state
  lastFetched: null,
  cacheValid: false,
  cacheExpiry: null,
  forceRefresh: false
};
